<template>
  <app-header class="report_header" :isReport="true">
    <template v-if="applyData" v-slot:extra>
      <a class="link_to_site" :href="applyData | applyUrl" target="_blank">
        <i class="icon icon--link-site-size20"></i>
      </a>
      <div class="site_area">
        <div class="url" href="#" @click.stop.prevent="togglePageList">
          <p class="site_url">
            <span class="matchType_string">{{ applyData.matchType | matchType }}</span>
            <span class="url_string">{{ applyData | applyUrlStr }}</span>
          </p>
          <i class="icon icon--url-btn"></i>
        </div>
      </div>
    </template>
  </app-header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import { triggerClickEvent } from '@/libs/utils'
import AppHeader from './'

export default {
  name: 'ReportHeader',
  components: {
    AppHeader
  },
  computed: {
    ...mapState([
      'applyData',
      'showReportPageList',
      'reportPeriod'
    ])
  },
  mounted () {
    EventBus.$on('closeReportPageList', () => {
      this.setShowReportPageList(false)
    })
  },
  methods: {
    ...mapMutations([
      'setShowReportPageList'
    ]),
    togglePageList () {
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      if (!this.showReportPageList) {
        triggerClickEvent()
      }
      this.setShowReportPageList(!this.showReportPageList)
    },
    onRangeCancel () {
      this.closePicker()
    }
  }
}
</script>

<style lang="scss">
.report_header {
  & > div {
    transition: all 0.3s;
  }

  .link_to_site {
    color: #fff;
    cursor: pointer;
    margin-right: 10px;
  }

  .site_area {
    position: relative;
    display: inline-block;
    height: 19px;
    top: 2px;
  }
  .site_area .type {
    height: 28px;
    line-height: 28px;
    display: inline-block;
    width: 100px;
    margin-right: 13px;
    border-radius: 5px;
    border: 1px solid #4fbae1;
    vertical-align: top;
    color: #4fbae1;
    text-align: center;
  }
  .site_area .url {
    display: inline-block;
    max-width: 500px;
    overflow: hidden;
  }
  .site_area .site_url {
    display: inline-block;
    overflow: hidden;
    max-width: 440px;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-wrap: normal;
  }
  .window .site_area .site_url {
    position: relative;
  }
  .site_area .site_url .matchType_string {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 4px;
    height: 16px;
    line-height: 16px;
    border-radius: 4px;
    background-color: #8d8d8d;
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-right: 8px;
  }
  .site_area .site_url .url_string{
    font-size: 14px;
    color: #444444;
  }
  .site_area svg {
    margin-left: 5px;
  }
  .site_area > .url {
    cursor: pointer;
  }
}
</style>
